import {
  buildAuthFileUrl,
  getBhpFileName,
  openAuthenticatedFile,
} from '@/functions/openAuthenticatedPrtFile';
import { AC } from '@/config';

const AUTH_FILE_ENDPOINTS = {
  critical_asset_documents: `${AC}/critical_asset_documents/`,
  spare_part_documents: `${AC}/spare_part_documents/`,
  catastrophic_risk_analysis_files: `${AC}/catastrophic_risk_analysis_files/`,
  discharge_part_files: `${AC}/discharge_part_files/`,
  action_document: `${AC}/action_document/`,
  action_documents: `${AC}/action_document/`,
  impact_percentage_files: `${AC}/impact_percentage_file/`,
  'custom/impact_percentage_files': `${AC}/impact_percentage_file/`,
  max_remediation_date_extension_justification: `${AC}/max_remediation_date_extension_justification/`,
  temporary_engineering_measure_files: `${AC}/temporary_engineering_measure_files/`,
  temv_files: `${AC}/temv_files/`,
};

export default {
  data() {
    return {
      opening_auth_file_ids: {},
    };
  },
  computed: {
    authFileEndpoint() {
      const name = this.config_name || this.name || '';
      if (AUTH_FILE_ENDPOINTS[name]) return AUTH_FILE_ENDPOINTS[name];
      if (String(name).includes('temv_files')) return AUTH_FILE_ENDPOINTS.temv_files;
      return this.auth_file_endpoint || null;
    },
  },
  methods: {
    resolveAuthFileUrl(item) {
      const endpoint = this.authFileEndpoint;
      if (item && item.id && endpoint) {
        return buildAuthFileUrl(endpoint, item.id);
      }
      if (item && item.id && this.isProtectedUploadUrl(item.document) && String(item.document).includes('/actions/documents/')) {
        return buildAuthFileUrl(AUTH_FILE_ENDPOINTS.action_document, item.id);
      }
      if (item && item.id && this.isProtectedUploadUrl(item.file_name) && String(item.file_name).includes('/impact_percentage_justifications/')) {
        return buildAuthFileUrl(AUTH_FILE_ENDPOINTS.impact_percentage_files, item.id);
      }
      if (item && item.id && this.isProtectedUploadUrl(item.document) && String(item.document).includes('/max_remediation_date_extension_justifications/')) {
        return buildAuthFileUrl(AUTH_FILE_ENDPOINTS.max_remediation_date_extension_justification, item.id);
      }
      if (item && item.id && this.isProtectedUploadUrl(item.document) && String(item.document).includes('/temporary_engineering_measures_verifications/')) {
        return buildAuthFileUrl(AUTH_FILE_ENDPOINTS.temv_files, item.id);
      }
      if (item && item.id && this.isProtectedUploadUrl(item.document) && String(item.document).includes('/temporary_engineering_measures/')) {
        return buildAuthFileUrl(AUTH_FILE_ENDPOINTS.temporary_engineering_measure_files, item.id);
      }
      return null;
    },
    resolveAuthFallbackRedirectUrl(item) {
      return getBhpFileName(item);
    },
    hasAuthFile(item) {
      return !!(item && (
        this.resolveAuthFileUrl(item)
        || (typeof item.document === 'string' && item.document)
        || (typeof item.file_name === 'string' && item.file_name)
      ));
    },
    is_auth_file_opening(item) {
      return !!(item && item.id && this.opening_auth_file_ids[item.id]);
    },
    isProtectedUploadUrl(url) {
      return typeof url === 'string' && url.includes('/uploads/');
    },
    async open_auth_file(item) {
      if (this.is_auth_file_opening(item)) return;
      const url = this.resolveAuthFileUrl(item);
      if (!url) {
        const publicUrl = (typeof item.document === 'string' && item.document) || (typeof item.file_name === 'string' && item.file_name);
        if (publicUrl && !this.isProtectedUploadUrl(publicUrl)) {
          window.open(publicUrl, '_blank', 'noopener,noreferrer');
        }
        return;
      }
      if (item && item.id) this.$set(this.opening_auth_file_ids, item.id, true);
      try {
        await openAuthenticatedFile(url, {
          beforeFetch: async () => {
            if (!await this.assignAccess()) throw new Error('no se pudo obtener acceso');
          },
          fallbackRedirectUrl: this.resolveAuthFallbackRedirectUrl(item),
        });
      } catch (e) {
        this.getError(e);
      } finally {
        if (item && item.id) this.$set(this.opening_auth_file_ids, item.id, false);
      }
    },
  },
};
